<template>
  <div>
    <div>
      <i18n
        v-if="expenses"
        tag="p"
        class="Fuell-Text"
        path="transactions_authorization_section_expenses_explanation"
      ></i18n>
      <i18n
        tag="p"
        class="Fuell-Text"
        path="transactions_authorization_section_explanation"
        v-else
      ></i18n>
    </div>

    <div class="Fuell-Toolbar">
      <div class="d-flex toolbar-column">
        <entity-search-input @search="fetchTransactions" />
        <date-select @selectDate="selectDate"></date-select>

      </div>
    </div>
    <transactions-table
      :tableName="tableName"
      :columns="columns"
      :expenses="expenses"
      @showReceiptModal="showReceiptModal"
      @showEditTransactionModal="showEditTransactionModal"
    ></transactions-table>
  </div>
</template>

<script>

import _transactionsIndexViewShared from '../../_mixins/_transactionsIndexViewShared'
import DateSelect from '../../../../components/Commons/Forms/DateSelect.vue'
import transactionPeriodsMixin from '@/modules/transactions/_mixins/_transactionPeriods'
import EntitySearchInput from '@/components/Commons/Search/EntitySearchInput'

export default {
  name: 'TransactionsAuthorizationsIndex',
  components: { DateSelect, EntitySearchInput },
  mixins: [_transactionsIndexViewShared, transactionPeriodsMixin],
  props: {
    expenses: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showTransactionExportModalFlag: false,
      section: 'Autorizaciones',
      transactionsSelectedTab: 'Autorizaciones',
      tableName: 'transactions'
    }
  },
  computed: {
    isUser () {
      return this.$store.getters['LoginStore/isUser']
    },
    columns () {
      return this.$store.getters['TransactionsStore/tableColumns'].filter(item => item.table ? item.table.includes(this.tableName) : item)
    },
    filters () {
      return { ...this.$store.getters['TransactionsStore/filters'] }
    }
  },

  methods: {
    async selectDate (filters) {
      await this.$store.dispatch('TransactionsStore/addTransactionsFilters', { ...this.filters, ...filters.filter })
      await this.$store.dispatch('TransactionsStore/fetchTransactionDashboard')
    },

    async fetchTransactions (event) {
      let defaultFilters = {
        'amountEqualZero': true,
        'type.code': 'NORMAL',
        ...this.periods.find(el => el.default).filter
      }
      if (this.filters['date[after]'] || this.filters['date[after]'] === null) {
        defaultFilters['date[after]'] = this.filters['date[after]']
      }
      if (this.filters['date[before]'] || this.filters['date[before]'] === null) {
        defaultFilters['date[before]'] = this.filters['date[before]']
      }
      if (this.isUser && this.userIsOwnerOfBudget && !this.expenses) {
        defaultFilters['imOwnerOfBudget'] = true
      }
      if (this.expenses) {
        defaultFilters['card.user.id'] = this.loggedUserId
      }
      let searchFilters = {}
      if (event && event.length >= 3) {
        searchFilters.query = event
      }

      let filters = event ? { ...defaultFilters, ...searchFilters } : { ...defaultFilters }
      await this.$store.dispatch('TransactionsStore/setTransactionsFilters', { filters: filters })
      await this.$store.dispatch('TransactionsStore/fetchTransactionDashboard')
    }
  },
  created () {
    this.section = this.expenses ? 'Historial' : 'Denegadas'
  }
}
</script>
<style scoped>
.Tabs {
  max-height: 40px;
}
.Tabs-Itm {
  align-items: center;
}
.Tabs-itmLink--curr {
  max-height: 40px;
}
.Tabs-itmLink {
  padding: 10px 20px;
  font-size: 0.9rem;
}
</style>

<style src="@/assets/styles/multiselect/multiselect-section-selector.css" scoped>
